export default __webpack_public_path__ + "static/media/Driver_screen_cut.92fd507b.jpg";